export enum UploadCredentialEntityEnum {
  imports = 'imports',
  equipments = 'equipments',
  maintenances = 'maintenances'
}

export interface UploadCredentialInput {
  size: number;
  extension: string;
  entity: UploadCredentialEntityEnum;
}

export interface UploadCredential {
  baseUrl: string;
  link: string;
  fields: UploadCredentialField;
}

export interface UploadCredentialField {
  [key: string]: string;
}

export interface UploadParams {
  imageBase64Encoded: string;
  filename: string;
  size?: number;
  path: string;
}

export interface UploadResponseBody {
  path: string;
  size?: number;
}

export interface BuildFormData {
  fields: UploadCredentialField;
  file: File;
}
